var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/fastdom/fastdom.js
var require_fastdom = __commonJS({
  "../../node_modules/fastdom/fastdom.js"(exports, module) {
    !function(win) {
      "use strict";
      var debug = 0 ? console.log.bind(console, "[fastdom]") : function() {
      };
      var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
        return setTimeout(cb, 16);
      };
      function FastDom() {
        var self = this;
        self.reads = [];
        self.writes = [];
        self.raf = raf.bind(win);
        debug("initialized", self);
      }
      FastDom.prototype = {
        constructor: FastDom,
        /**
         * We run this inside a try catch
         * so that if any jobs error, we
         * are able to recover and continue
         * to flush the batch until it's empty.
         *
         * @param {Array} tasks
         */
        runTasks: function(tasks) {
          debug("run tasks");
          var task;
          while (task = tasks.shift()) task();
        },
        /**
         * Adds a job to the read batch and
         * schedules a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        measure: function(fn, ctx) {
          debug("measure");
          var task = !ctx ? fn : fn.bind(ctx);
          this.reads.push(task);
          scheduleFlush(this);
          return task;
        },
        /**
         * Adds a job to the
         * write batch and schedules
         * a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        mutate: function(fn, ctx) {
          debug("mutate");
          var task = !ctx ? fn : fn.bind(ctx);
          this.writes.push(task);
          scheduleFlush(this);
          return task;
        },
        /**
         * Clears a scheduled 'read' or 'write' task.
         *
         * @param {Object} task
         * @return {Boolean} success
         * @public
         */
        clear: function(task) {
          debug("clear", task);
          return remove(this.reads, task) || remove(this.writes, task);
        },
        /**
         * Extend this FastDom with some
         * custom functionality.
         *
         * Because fastdom must *always* be a
         * singleton, we're actually extending
         * the fastdom instance. This means tasks
         * scheduled by an extension still enter
         * fastdom's global task queue.
         *
         * The 'super' instance can be accessed
         * from `this.fastdom`.
         *
         * @example
         *
         * var myFastdom = fastdom.extend({
         *   initialize: function() {
         *     // runs on creation
         *   },
         *
         *   // override a method
         *   measure: function(fn) {
         *     // do extra stuff ...
         *
         *     // then call the original
         *     return this.fastdom.measure(fn);
         *   },
         *
         *   ...
         * });
         *
         * @param  {Object} props  properties to mixin
         * @return {FastDom}
         */
        extend: function(props) {
          debug("extend", props);
          if (typeof props != "object") throw new Error("expected object");
          var child = Object.create(this);
          mixin(child, props);
          child.fastdom = this;
          if (child.initialize) child.initialize();
          return child;
        },
        // override this with a function
        // to prevent Errors in console
        // when tasks throw
        catch: null
      };
      function scheduleFlush(fastdom2) {
        if (!fastdom2.scheduled) {
          fastdom2.scheduled = true;
          fastdom2.raf(flush.bind(null, fastdom2));
          debug("flush scheduled");
        }
      }
      function flush(fastdom2) {
        debug("flush");
        var writes = fastdom2.writes;
        var reads = fastdom2.reads;
        var error;
        try {
          debug("flushing reads", reads.length);
          fastdom2.runTasks(reads);
          debug("flushing writes", writes.length);
          fastdom2.runTasks(writes);
        } catch (e) {
          error = e;
        }
        fastdom2.scheduled = false;
        if (reads.length || writes.length) scheduleFlush(fastdom2);
        if (error) {
          debug("task errored", error.message);
          if (fastdom2.catch) fastdom2.catch(error);
          else throw error;
        }
      }
      function remove(array, item) {
        var index = array.indexOf(item);
        return !!~index && !!array.splice(index, 1);
      }
      function mixin(target, source) {
        for (var key in source) {
          if (source.hasOwnProperty(key)) target[key] = source[key];
        }
      }
      var exports2 = win.fastdom = win.fastdom || new FastDom();
      if (typeof define == "function") define(function() {
        return exports2;
      });
      else if (typeof module == "object") module.exports = exports2;
    }(typeof window !== "undefined" ? window : typeof exports != "undefined" ? exports : globalThis);
  }
});

// ../../node_modules/@wix/image/dist/esm/Image.js
import * as React from "react";

// ../../node_modules/@wix/image/dist/esm/Image.scss
var Image_default = {};

// ../../node_modules/@wix/image/dist/esm/Image.js
import * as imageKit from "@wix/image-kit";
var { STATIC_MEDIA_URL } = imageKit;
var fetchLQIP = ({ fittingType, src, target, options }) => {
  const placeholder = imageKit.getPlaceholder(fittingType, src, target, __spreadProps(__spreadValues({}, options), {
    autoEncode: true
  }));
  if ((placeholder == null ? void 0 : placeholder.uri) && !/^[a-z]+:/.test(placeholder.uri)) {
    placeholder.uri = `${STATIC_MEDIA_URL}${placeholder.uri}`;
  }
  return placeholder;
};
var SCHEME_RE = /^[a-z]+:/;
var Image = (props) => {
  var _a, _b;
  const { id, containerId, uri, alt, name = "", role, width, height, displayMode, devicePixelRatio, quality, alignType, bgEffectName = "", focalPoint, upscaleMethod, className = "", crop, imageStyles = {}, targetWidth, targetHeight, targetScale, onLoad = () => {
  }, onError = () => {
  }, shouldUseLQIP, containerWidth, containerHeight, getPlaceholder: getPlaceholder2, isInFirstFold, placeholderTransition, socialAttrs, isSEOBot, skipMeasure, lazyLoadImgExperimentOpen, hasAnimation, allowWEBPTransform } = props;
  const imageRef = React.useRef(null);
  let hasSsrSrc = "";
  const hasBlurTransition = placeholderTransition === "blur";
  const ssrImageData = React.useRef(null);
  if (!ssrImageData.current) {
    if (getPlaceholder2 || shouldUseLQIP || isInFirstFold || isSEOBot) {
      const options = __spreadProps(__spreadValues({
        upscaleMethod
      }, quality ? quality : {}), {
        shouldLoadHQImage: isInFirstFold,
        isSEOBot,
        hasAnimation,
        allowWEBPTransform
      });
      ssrImageData.current = (getPlaceholder2 || fetchLQIP)({
        fittingType: displayMode,
        src: {
          id: uri,
          width,
          height,
          crop,
          name,
          focalPoint
        },
        target: {
          width: containerWidth,
          height: containerHeight,
          alignment: alignType,
          htmlTag: "img"
        },
        options
      });
      hasSsrSrc = !ssrImageData.current.transformed || isInFirstFold || isSEOBot ? "" : "true";
    } else {
      ssrImageData.current = {
        uri: void 0,
        css: { img: {} },
        attr: { img: {}, container: {} },
        transformed: false
      };
    }
  }
  const isLQIP = !isSEOBot && (getPlaceholder2 || shouldUseLQIP) && !isInFirstFold && ssrImageData.current.transformed;
  const imageInfo = React.useMemo(() => JSON.stringify(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
    containerId
  }, containerId && { containerId }), alignType && { alignType }), skipMeasure && { skipMeasure: true }), {
    displayMode
  }), containerWidth && { targetWidth: containerWidth }), containerHeight && { targetHeight: containerHeight }), targetWidth && { targetWidth }), targetHeight && { targetHeight }), targetScale && { targetScale }), {
    isLQIP,
    isSEOBot,
    lqipTransition: placeholderTransition,
    imageData: __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
      width,
      height,
      uri,
      name,
      displayMode,
      hasAnimation
    }, quality && { quality }), devicePixelRatio && { devicePixelRatio }), focalPoint && { focalPoint }), crop && { crop }), upscaleMethod && { upscaleMethod })
  })), [
    containerId,
    alignType,
    skipMeasure,
    displayMode,
    containerHeight,
    containerWidth,
    targetWidth,
    targetHeight,
    targetScale,
    isLQIP,
    isSEOBot,
    placeholderTransition,
    width,
    height,
    uri,
    name,
    quality,
    devicePixelRatio,
    focalPoint,
    crop,
    upscaleMethod,
    hasAnimation
  ]);
  const ssrResult = ssrImageData.current;
  const src = ssrResult == null ? void 0 : ssrResult.uri;
  const srcset = ssrResult == null ? void 0 : ssrResult.srcset;
  const placeholderStyle = (_a = ssrResult.css) == null ? void 0 : _a.img;
  const classNames = `${Image_default.image} ${className}`;
  React.useEffect(() => {
    const imgElment = imageRef.current;
    if (onLoad && (imgElment == null ? void 0 : imgElment.currentSrc) && (imgElment == null ? void 0 : imgElment.complete)) {
      onLoad({
        target: imageRef.current
      });
    }
  }, []);
  const maxWidth = ssrResult && !(ssrResult == null ? void 0 : ssrResult.transformed) ? `max(${width}px, 100%)` : targetWidth ? `${targetWidth}px` : null;
  return React.createElement(
    "wow-image",
    { id, class: classNames, "data-image-info": imageInfo, "data-bg-effect-name": bgEffectName, "data-has-ssr-src": hasSsrSrc, "data-animate-blur": !isSEOBot && isLQIP && hasBlurTransition ? "" : void 0, style: maxWidth ? { "--wix-img-max-width": maxWidth } : {} },
    React.createElement("img", __spreadValues(__spreadValues(__spreadValues(__spreadValues({ src, ref: imageRef, alt: alt || "", role, style: __spreadValues(__spreadValues({}, placeholderStyle), imageStyles), onLoad, onError }, containerWidth && { width: containerWidth }), containerHeight && { height: containerHeight }), socialAttrs), isInFirstFold ? {
      srcSet: (_b = srcset == null ? void 0 : srcset.dpr) == null ? void 0 : _b.map((s) => SCHEME_RE.test(s) ? s : `${STATIC_MEDIA_URL}${s}`).join(", "),
      fetchpriority: "high"
    } : lazyLoadImgExperimentOpen ? { loading: "lazy" } : {}))
  );
};

// ../../node_modules/@wix/image/dist/esm/customElementInit.js
var import_fastdom = __toESM(require_fastdom());

// ../../node_modules/@wix/image/dist/esm/custom-element/utils.js
import { alignTypes, fittingTypes, getData, isWEBP } from "@wix/image-kit";
var CSS_NUMERIC_VALUES = {
  columnCount: 1,
  columns: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  zIndex: 1,
  zoom: 1
};
var pick = (obj, props) => {
  const propsArr = Array.isArray(props) ? props : [props];
  return propsArr.reduce((subObj, prop) => {
    const val = obj[prop];
    return val !== void 0 ? Object.assign(subObj, { [prop]: val }) : subObj;
  }, {});
};
var addDefaultUnitIfNeeded = (prop, value) => typeof value === "number" && !CSS_NUMERIC_VALUES[prop] ? `${value}px` : value;
var setStyle = (node, styleProperties) => node && styleProperties && Object.keys(styleProperties).forEach((prop) => {
  const propValue = styleProperties[prop];
  if (propValue !== void 0) {
    node.style[prop] = addDefaultUnitIfNeeded(prop, propValue);
  } else {
    node.style.removeProperty(prop);
  }
});
var getScreenHeight = (heightOverride) => heightOverride || document.documentElement.clientHeight || window.innerHeight || 0;
var getImageComputedProperties = (extendedImageInfo, envConsts, htmlTag, allowWEBPTransform) => {
  if (!extendedImageInfo.targetWidth || !extendedImageInfo.targetHeight || !extendedImageInfo.imageData.uri) {
    return { uri: "", css: {}, transformed: false };
  }
  const { imageData } = extendedImageInfo;
  const fittingType = extendedImageInfo.displayMode || fittingTypes.SCALE_TO_FILL;
  const imageOptions = Object.assign(pick(imageData, ["upscaleMethod", "hasAnimation"]), pick(extendedImageInfo, "filters"), extendedImageInfo.quality || imageData.quality, allowWEBPTransform && { allowWEBPTransform });
  const devicePixelRatioFromData = extendedImageInfo.imageData.devicePixelRatio || envConsts.devicePixelRatio;
  const devicePixelRatio = getDevicePixelRatio(devicePixelRatioFromData);
  const src = Object.assign(pick(imageData, ["width", "height", "crop", "name", "focalPoint"]), { id: imageData.uri });
  const target = {
    width: extendedImageInfo.targetWidth,
    height: extendedImageInfo.targetHeight,
    htmlTag: htmlTag || "img",
    pixelAspectRatio: devicePixelRatio,
    alignment: extendedImageInfo.alignType || alignTypes.CENTER
  };
  const imageComputedProperties = getData(fittingType, src, target, imageOptions);
  imageComputedProperties.uri = getMediaUrlByContext(imageComputedProperties.uri, envConsts.staticMediaUrl, envConsts.mediaRootUrl);
  return imageComputedProperties;
};
var getMediaUrlByContext = (imageUri, staticMediaUrl, mediaRootUrl) => {
  var _a;
  const isExternalUrl = /(^https?)|(^data)|(^blob)|(^\/\/)/.test(imageUri);
  if (isExternalUrl) {
    return imageUri;
  }
  let path = `${staticMediaUrl}/`;
  if (imageUri) {
    if (/^micons\//.test(imageUri)) {
      path = mediaRootUrl;
    } else if (((_a = /[^.]+$/.exec(imageUri)) == null ? void 0 : _a[0]) === "ico") {
      path = path.replace("media", "ficons");
    }
  }
  return path + imageUri;
};
var getDevicePixelRatio = (devicePixelRatio) => {
  const queryParams = window.location.search.split("&").map((query) => query.split("="));
  const devicePixelRatioQueryParam = queryParams.find((query) => query[0].toLowerCase().includes("devicepixelratio"));
  const devicePixelRatioValueForceFromUrl = devicePixelRatioQueryParam ? Number(devicePixelRatioQueryParam[1]) : null;
  return devicePixelRatioValueForceFromUrl || devicePixelRatio || 1;
};
var getImageSrc = (imageNode) => imageNode.getAttribute("src");
var isTransformedWEBP = (imageNode, imageUri) => {
  const src = getImageSrc(imageNode) || "";
  const isTransformed = !!src.match(/.webp\/v1\//);
  return isWEBP(imageUri) && isTransformed;
};

// ../../node_modules/@wix/image/dist/esm/custom-element/imageLayout.js
var MOBILE_SAFE_ADDRESSBAR_HEIGHT = 80;
function getHeightOverride(height, mediaHeightOverrideType) {
  return mediaHeightOverrideType === "fixed" || mediaHeightOverrideType === "viewport" ? document.documentElement.clientHeight + MOBILE_SAFE_ADDRESSBAR_HEIGHT : height;
}
function computeScaleOverrides(imageStyle, targetScale = 1) {
  return targetScale !== 1 ? __spreadProps(__spreadValues({}, imageStyle), {
    width: "100%",
    height: "100%"
  }) : imageStyle;
}
function computeStyleOverrides(mediaHeightOverrideType, imageStyle, displayMode, targetScale, isResponsive) {
  const styleWithScale = computeScaleOverrides(imageStyle, targetScale);
  if (isResponsive) {
    delete styleWithScale.height;
    styleWithScale.width = "100%";
  }
  if (!mediaHeightOverrideType) {
    return styleWithScale;
  }
  const style = __spreadValues({}, styleWithScale);
  if (displayMode === "fill") {
    style.position = "absolute";
    style.top = "0";
  } else if (displayMode === "fit") {
    style.height = "100%";
  }
  if (mediaHeightOverrideType === "fixed") {
    style["will-change"] = "transform";
  }
  if (style.objectPosition) {
    style.objectPosition = imageStyle.objectPosition.replace(/(center|bottom)$/, "top");
  }
  return style;
}
function getSourceSetsTargetHeightByEffect(sourceSets, offsetWidth, offsetHeight, screenHeight, services) {
  const sourceSetsTargetHeights = {};
  sourceSets.forEach(({ mediaQuery, scrollEffect }) => {
    sourceSetsTargetHeights[mediaQuery] = services.getMediaDimensionsByEffect(scrollEffect, offsetWidth, offsetHeight, screenHeight).height;
  });
  return sourceSetsTargetHeights;
}
function computeSrcSets(measures, imageInfo, envConsts) {
  const { sourceSets } = imageInfo;
  if (!sourceSets || !sourceSets.length) {
    return;
  }
  const mediaToUri = {};
  sourceSets.forEach(({ mediaQuery, crop, focalPoint }) => {
    const imageInfoClone = __spreadProps(__spreadValues({}, imageInfo), {
      targetHeight: (measures.sourceSetsTargetHeights || {})[mediaQuery] || 0,
      imageData: __spreadProps(__spreadValues({}, imageInfo.imageData), {
        crop,
        focalPoint
      })
    });
    const imageComputedProperties = getImageComputedProperties(imageInfoClone, envConsts, "img");
    mediaToUri[mediaQuery] = imageComputedProperties.uri || "";
  });
  return mediaToUri;
}
function measure(id, measures, domNodes, { containerElm, bgEffect = "none", sourceSets }, services) {
  var _a, _b;
  const innerImage = domNodes.image;
  const wixImage = domNodes[id];
  const screenHeight = getScreenHeight((_a = services.getScreenHeightOverride) == null ? void 0 : _a.call(services));
  const mediaHeightOverrideType = containerElm == null ? void 0 : containerElm.dataset.mediaHeightOverrideType;
  const sourceOfDimensions = containerElm && bgEffect && bgEffect !== "none" ? containerElm : wixImage;
  const { width, height } = ((_b = services.getMediaDimensionsByEffect) == null ? void 0 : _b.call(services, bgEffect, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight)) || {
    width: wixImage.offsetWidth,
    height: wixImage.offsetHeight
  };
  if (sourceSets) {
    measures.sourceSetsTargetHeights = getSourceSetsTargetHeightByEffect(sourceSets, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight, services);
  }
  if (!innerImage) {
    return;
  }
  const imgSrc = getImageSrc(innerImage);
  measures.width = width;
  measures.height = getHeightOverride(height, mediaHeightOverrideType);
  measures.screenHeight = screenHeight;
  measures.imgSrc = imgSrc;
  measures.boundingRect = wixImage.getBoundingClientRect();
  measures.mediaHeightOverrideType = mediaHeightOverrideType;
}
function patch(id, measures, domNodes, imageInfo, services, envConsts, loadImage, isResponsive, bgEffect) {
  var _a, _b;
  if (!Object.keys(measures).length) {
    return;
  }
  const { imageData } = imageInfo;
  const wixImageNode = domNodes[id];
  const image = domNodes.image;
  if (bgEffect) {
    imageData.devicePixelRatio = 1;
  }
  const targetScale = imageInfo.targetScale || 1;
  const extendedImageInfo = __spreadProps(__spreadValues(__spreadValues({}, imageInfo), !imageInfo.skipMeasure && {
    targetWidth: (measures.width || 0) * targetScale,
    targetHeight: (measures.height || 0) * targetScale
  }), {
    displayMode: imageData.displayMode
  });
  const allowWEBPTransform = ((_a = services.isExperimentOpen) == null ? void 0 : _a.call(services, "specs.thunderbolt.allowWEBPTransformation")) && isTransformedWEBP(image, imageData.uri);
  const imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, "img", allowWEBPTransform);
  const computedStyle = ((_b = imageComputedProperties == null ? void 0 : imageComputedProperties.css) == null ? void 0 : _b.img) || {};
  const imageStyle = computeStyleOverrides(measures.mediaHeightOverrideType, computedStyle, imageData.displayMode, targetScale, isResponsive);
  setStyle(image, imageStyle);
  const src = (imageComputedProperties == null ? void 0 : imageComputedProperties.uri) || "";
  wixImageNode.setAttribute("data-src", src);
  const mediaToUri = computeSrcSets(measures, extendedImageInfo, envConsts);
  wixImageNode.setAttribute("data-has-ssr-src", "");
  if (imageInfo.isLQIP && imageInfo.lqipTransition && !("transitioned" in wixImageNode.dataset)) {
    wixImageNode.dataset.transitioned = "";
    if (image.complete) {
      image.onload = function() {
        image.dataset.loadDone = "";
      };
    } else {
      image.onload = function() {
        if (image.complete) {
          image.dataset.loadDone = "";
        } else {
          image.onload = function() {
            image.dataset.loadDone = "";
          };
        }
      };
    }
  }
  if (loadImage) {
    image.setAttribute("fetchpriority", "high");
    image.currentSrc !== src && image.setAttribute("src", src);
    image.srcset && image.srcset !== src && image.setAttribute("srcset", src);
    if (domNodes.picture && extendedImageInfo.sourceSets) {
      Array.from(domNodes.picture.querySelectorAll("source")).forEach((sourceNode) => {
        const mediaQuery = sourceNode.media || "";
        const uri = mediaToUri ? mediaToUri[mediaQuery] : "";
        sourceNode.srcset !== uri && sourceNode.setAttribute("srcset", uri);
      });
    }
  }
}
var imageLayout_default = {
  measure,
  patch
};

// ../../node_modules/@wix/image/dist/esm/custom-element/WowImage.js
var TIMEOUT = 250;
var imageEffectMap = {
  parallax: "ImageParallax",
  fixed: "ImageReveal"
};
function wowImageFactory(services, environmentConsts, contextWindow) {
  return class WowImage extends contextWindow.HTMLElement {
    constructor() {
      super();
      this.childListObserver = null;
      this.timeoutId = null;
    }
    attributeChangedCallback(_, oldValue) {
      if (oldValue) {
        this.reLayout();
      }
    }
    connectedCallback() {
      if (environmentConsts.disableImagesLazyLoading) {
        this.reLayout();
      } else {
        this.observeIntersect();
      }
    }
    disconnectedCallback() {
      this.unobserveResize();
      this.unobserveIntersect();
      this.unobserveChildren();
    }
    static get observedAttributes() {
      return ["data-image-info"];
    }
    reLayout() {
      const domNodes = {};
      const measures = {};
      const imageId = this.getAttribute("id");
      const imageInfo = JSON.parse(this.dataset.imageInfo || "");
      const isResponsive = this.dataset.isResponsive === "true";
      const { bgEffectName } = this.dataset;
      const { scrollEffect } = imageInfo.imageData;
      const { sourceSets } = imageInfo;
      const bgEffect = bgEffectName || imageEffectMap[scrollEffect];
      if (sourceSets && sourceSets.length) {
        sourceSets.forEach((sourceSet) => {
          if (sourceSet.scrollEffect) {
            sourceSet.scrollEffect = imageEffectMap[sourceSet.scrollEffect];
          }
        });
      }
      domNodes[imageId] = this;
      if (imageInfo.containerId) {
        domNodes[imageInfo.containerId] = contextWindow.document.getElementById(`${imageInfo.containerId}`);
      }
      const containerElm = imageInfo.containerId ? domNodes[imageInfo.containerId] : void 0;
      domNodes.image = this.querySelector("img");
      domNodes.picture = this.querySelector("picture");
      if (!domNodes.image) {
        const target = this;
        this.observeChildren(target);
        return;
      }
      this.unobserveChildren();
      this.observeChildren(this);
      services.mutationService.measure(() => {
        imageLayout_default.measure(imageId, measures, domNodes, {
          containerElm,
          bgEffect,
          sourceSets
        }, services);
      });
      const patchImage = (shouldLoadImage) => {
        services.mutationService.mutate(() => {
          imageLayout_default.patch(imageId, measures, domNodes, imageInfo, services, environmentConsts, shouldLoadImage, isResponsive, bgEffect);
        });
      };
      if (!getImageSrc(domNodes.image) || this.dataset.hasSsrSrc) {
        patchImage(true);
      } else {
        this.debounceImageLoad(patchImage);
      }
    }
    /**
     * Debounce consecutive image loads
     *
     * @param {function} patchImage closure for patching the image
     */
    debounceImageLoad(patchImage) {
      clearTimeout(this.timeoutId);
      this.timeoutId = contextWindow.setTimeout(() => {
        patchImage(true);
      }, TIMEOUT);
      patchImage(false);
    }
    observeResize() {
      var _a;
      (_a = services.resizeService) == null ? void 0 : _a.observe(this);
    }
    unobserveResize() {
      var _a;
      (_a = services.resizeService) == null ? void 0 : _a.unobserve(this);
    }
    observeIntersect() {
      var _a;
      (_a = services.intersectionService) == null ? void 0 : _a.observe(this);
    }
    unobserveIntersect() {
      var _a;
      (_a = services.intersectionService) == null ? void 0 : _a.unobserve(this);
    }
    /**
     * Observe DOM mutations to wait for addition of missing children
     *
     * @param {HTMLElement} parent
     */
    observeChildren(parent) {
      if (!this.childListObserver) {
        this.childListObserver = new contextWindow.MutationObserver(() => {
          this.reLayout();
        });
      }
      this.childListObserver.observe(parent, { childList: true });
    }
    /**
     * Remove DOM MutationObserver if one was created
     */
    unobserveChildren() {
      if (this.childListObserver) {
        this.childListObserver.disconnect();
        this.childListObserver = null;
      }
    }
  };
}
var WowImage_default = wowImageFactory;

// ../../node_modules/@wix/image/dist/esm/custom-element/registry.js
function init(contextWindow) {
  const elementName = "wow-image";
  contextWindow = contextWindow || window;
  if (contextWindow.customElements.get(elementName) === void 0) {
    let resizeObserver;
    if (contextWindow.ResizeObserver) {
      resizeObserver = new contextWindow.ResizeObserver((entries) => entries.map((entry) => entry.target.reLayout()));
    }
    let intersectionObserver;
    if (contextWindow.IntersectionObserver) {
      intersectionObserver = new IntersectionObserver((entries, observer) => entries.map((entry) => {
        if (entry.isIntersecting) {
          const wowImage = entry.target;
          wowImage.unobserveIntersect();
          wowImage.observeResize();
        }
        return entry;
      }), { rootMargin: "50% 0px" });
    }
    return function(services, env) {
      const WowImage = WowImage_default(__spreadValues({
        resizeService: resizeObserver,
        intersectionService: intersectionObserver
      }, services), env, contextWindow);
      contextWindow.customElements.define(elementName, WowImage);
    };
  }
  return;
}

// ../../node_modules/@wix/image/dist/esm/customElementInit.js
var getDevicePixelRatio2 = () => {
  const isMSMobileDevice = /iemobile/i.test(navigator.userAgent);
  if (isMSMobileDevice) {
    return Math.round(window.screen.availWidth / (window.screen.width || window.document.documentElement.clientWidth));
  }
  return window.devicePixelRatio;
};
var STATIC_MEDIA_URL2 = "https://static.wixstatic.com/media";
var MEDIA_ROOT_URL = "https://static.wixstatic.com";
function initCustomElement(services = {}, contextWindow = null, envConsts = {}) {
  if (typeof window === "undefined") {
    return;
  }
  const env = __spreadValues({
    staticMediaUrl: STATIC_MEDIA_URL2,
    mediaRootUrl: MEDIA_ROOT_URL,
    experiments: {},
    devicePixelRatio: getDevicePixelRatio2()
  }, envConsts);
  const define2 = init(contextWindow);
  if (define2) {
    define2(__spreadValues({ mutationService: import_fastdom.default }, services), env);
  }
}
export {
  Image,
  initCustomElement
};
//# sourceMappingURL=wix-image.js.map
